import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {SortDirection} from "@swimlane/ngx-datatable";
import {EMPTY} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {CustomToastService} from "../../../@core/utils/custom-toast.service";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {StudentTicketService} from "../../../@core/services/student-ticket/student-ticket.service";
import {
  StudentTicketListViewAsmResponseDTO
} from "../../../models/student-ticket/list-view/StudentTicketListViewAsmResponseDTO";
import {IPagedResponse} from "../../../models/paged-bulkfetch/IPagedResponse";
import {
  StudentTicketListViewRequestDTO
} from "../../../models/student-ticket/list-view/StudentTicketListViewRequestDTO";
import {CompositMessageService} from "../../../@core/services/compositMessage/compositMessage.service";


@Component({
    selector: 'app-ticket-list',
    templateUrl: './student-ticket-list.component.html',
    styleUrl: './student-ticket-list.component.scss',
    standalone: false
})
export class StudentTicketListComponent implements OnInit{

  isSearching = false;

  // update paging here, then call reloadTable
  currentPage = { // default page 0
    page: 0,
    size: 10,
    sortDir: SortDirection.asc
  };

  // update filters here, then call reloadTable
  filterDto : StudentTicketListViewRequestDTO = {  // default: no filters, no search keywords
    keywords : undefined,
  };

  responseDto : IPagedResponse<StudentTicketListViewAsmResponseDTO>;

  entityNameTranslationKey = 'STUDENT_TICKET';

  ticketListForm: UntypedFormGroup = {} as UntypedFormGroup;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly studentTicketService : StudentTicketService,
    public translateService: TranslateService,
    private readonly compositMessageService: CompositMessageService,
    private readonly customToastService: CustomToastService
  ) {}

  ngOnInit(): void {
    this.setEmptyResponseDto();
    this.initEmptyForms();
    this.reloadTickets();
  }

  initEmptyForms(){
    this.ticketListForm = this.fb.group(
      {
        suche: [""],
      });
  }

  reloadTickets() {
    this.isSearching = true;
    this.studentTicketService.getTicketList({
      page  : this.currentPage.page,
      size  : this.currentPage.size,
      sortDir : this.currentPage.sortDir,
      requestDto : this.filterDto
    })
      .subscribe({
          next: (data : IPagedResponse<StudentTicketListViewAsmResponseDTO>) => {
            this.responseDto = data;
            this.currentPage.page = data?.number;
            this.isSearching = false;
          },
          error: (err) => {
            this.customToastService.showError(this.compositMessageService.createErrorMessage(err,this.entityNameTranslationKey,'getBulk'));
            this.setEmptyResponseDto();
            this.isSearching = false;
            return EMPTY;
          }
      });
  }

  setEmptyResponseDto(){
    this.responseDto = {
      content: [], number: 0, numberOfElements: 0, size: 10, totalElements: 0, totalPages: 0
    };
  }

  onPageChange(page: number): void {
    this.currentPage.page = page - 1;
    this.reloadTickets();
  }

  onSearchChange(): void {
    this.filterDto.keywords = this.ticketListForm.get('suche')?.value;
    this.reloadTickets();
  }

  onClearSearchTerm() {
    this.filterDto.keywords = "";
    this.reloadTickets();
  }

  protected readonly faSearch = faSearch;

}
